import { useEffect, useState } from "react";


function getWindowDimensions(){
    const {innerWidth: width , innerHeight: height} = window;
    return {width, height};
}

export default function useWindowDimensions(){
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions);

    useEffect(() => {
        function handleResize(){
            setWindowDimensions(getWindowDimensions());
        };

        window.addEventListener('resize', handleResize);
        console.log(windowDimensions);
        return () => window.removeEventListener('resize', handleResize)
    }, [windowDimensions])

    return windowDimensions;
}


